import React, { useEffect, useState } from "react";
import DashboardMain_Bus from "../../DashboardMain_Bus/DashboardMain_Bus";
import ToggleButtonBar from "./SubHeader/ToggleButtonBar";
import CustomFilter from "./FilterTCU/CustomFilter";
import { TCUContextProvider } from "./Context";
import KpisTCU from "./Kpis/KPI";
import LostTCUAgeingTable from "./LostTCUTable/TableTCU";
import DeviceHealth from "./DeviceHealth/DeviceHealth";
import LatencyHome from "./Latency/LatencyHome";
import INGHomePage from "../ING/INGHomePage";
import { loggingApiTCU } from "../../../../services/cesl-bus/tcuService";

const TCUHomePage = () => {
  const [activeTab, setActiveTab] = useState("Home");

  useEffect(() => {
    loggingApiTCU();
  }, []);

  return (
    <TCUContextProvider>
      <div style={{ backgroundColor: "#f2f3fc", minHeight: "100vh" }}>
        <DashboardMain_Bus>
          <div className="container-fluid ">
            <ToggleButtonBar
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />

            {activeTab === "Home" ? (
              <>
                <CustomFilter />
                <KpisTCU />
                <LostTCUAgeingTable />
              </>
            ) : activeTab === "Device Health" ? (
              <DeviceHealth />
            ) : activeTab === "Latency" ? (
              <LatencyHome />
            ) : activeTab === "ING Report" ? (
              <INGHomePage />
            ) : (
              <></>
            )}
          </div>
        </DashboardMain_Bus>
      </div>
    </TCUContextProvider>
  );
};

export default TCUHomePage;
 